import React, { useState, useEffect } from "react";
import CalendarComponent from "../React_Components/CalendarComponen";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import qs from 'qs';
import { useNavigate } from "react-router-dom";
import ErrorModal from "../Security/ErrorModal";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import CustomDropdown from "../../CustomControls/dropdown";


const CalendarView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { selectedType, appointmentType, SlotType } = location.state || {};
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  console.log("Selected Type:", selectedType);
  console.log("Appointment Type:", appointmentType);
  console.log("Slot Type:", SlotType);
  const [loading, setLoading] = useState(true);

  // Get ServiceDescription and Contract from Redux store
  const emailId = useSelector((state) => state.userData);
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const [ selectedTimeZoneOffset, setSelectedTimeZoneOffset ] = useState('');
  const [selectedTimeZone, setSelectedTimeZone] = useState("");
  const [calendarDates, setCalendarDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [timeZoneData, setTimeZoneData] = useState([]);
  const [activityIndicator, setActivityIndicator] = useState(false);
  const [formattedDate, setFormattedDate] = useState('');
  const [timeZone1, setTimeZone] = useState('');
  const [OffSet, setOffSet] = useState(''); 
  const [OffsetDiff, setOffsetDiff] = useState('');
  const [currentMonth, setCurrentMonth] = useState(null);
  const [calendarType, setCalendarType] = useState(selectedType === 'Nurse' ? '' : 'All');
  const [loadCalendarInfo,setLoadCalendarInfo]= useState([]);
  const [isItemsLoading, setIsItemsLoading] = useState(false);

  const fetchTimeZones = async () => {
    setActivityIndicator(true);
    setIsItemsLoading(true);
    try {
      const token = localStorage.getItem("AccessToken");
            const response = await axios.post(
              Endpoints.GetTimeZones,
              {
                _params: JSON.stringify({
                  EmailID: emailId.userData.EmailID,
                  DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
                })},
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                  "Connection": "close",
                  "Accept": "*/*",
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            const data = response.data;
            
            if (Array.isArray(data)){
      // Simulate an API call to fetch time zones
      setTimeZoneData(data);

      const EST_TIME_ZONES = [
        "America/New_York",
        "America/Detroit",
        "America/Indiana/Indianapolis",
        "America/Indiana/Marengo",
        "America/Indiana/Vevay",
        "America/Kentucky/Louisville",
        "America/Kentucky/Monticello",
        "America/Nassau",
        "America/Toronto",
        "America/Montreal",
        "America/Iqaluit",
        "America/Pangnirtung",
        "America/Port-au-Prince",
        "America/Havana",
        "America/Indiana/Petersburg",
        "America/Indiana/Vincennes",
        "America/Indiana/Winamac",
        "America/Thunder_Bay",
        "America/Cayman",
        "America/Guayaquil",
      ];

      // After fetching, set the time zone based on user’s time zone
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      var utcDiff='';
      if (EST_TIME_ZONES.includes(userTimeZone)) {
        setTimeZone('Eastern Standard Time'); // Adjust this as needed
        const utcDiffObj = data.find((tz) => tz.TimeZone === 'Eastern Standard Time');
        utcDiff=utcDiffObj.UTCOffset;
        setSelectedTimeZone(`UTC(${utcDiff}) Eastern Standard Time`)
      } else{

      let matchedTimeZone = data.find(tz => tz.TimeZone === userTimeZone);
      
      if (matchedTimeZone) {
        setTimeZone(`${matchedTimeZone.TimeZone}`);
        setSelectedTimeZone(`UTC${matchedTimeZone.UTCOffset} ${matchedTimeZone.TimeZone}`);
      } else {
        const utcDiff = getUTCDifference(); // Define a function to get UTC offset difference
        matchedTimeZone = data.find(tz => tz.UTCOffset === utcDiff);

        if (matchedTimeZone) {
          setTimeZone(`${matchedTimeZone.TimeZone}`);
          setSelectedTimeZone(`UTC${matchedTimeZone.UTCOffset} ${matchedTimeZone.TimeZone}`);
        } else {
          // Fallback to a default time zone if no matches are found
          setTimeZone('Eastern Standard Time'); // Adjust this as needed
          setSelectedTimeZone('UTC(-04:00) Eastern Standard Time')
        }
      }
    }}} catch (error) {
      console.error('Error fetching time zones:', error);
    } finally {
      setActivityIndicator(false);
      setIsItemsLoading(false);
    }
  };

  const getUTCDifference = () => {
    const date = new Date();
    const offset = -date.getTimezoneOffset(); // Get the offset in minutes
    const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, '0'); // Calculate hours
    const minutes = String(Math.abs(offset) % 60).padStart(2, '0'); // Calculate minutes
    return (offset < 0 ? '-' : '+') + hours + ':' + minutes;
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.resetCalendarGlobals?.();
    }
    fetchTimeZones();
    const resetState = sessionStorage.getItem('clearStateOnBack');
    if (resetState) {
      // Clear your state if the flag is set
      sessionStorage.removeItem('clearStateOnBack');
      setSelectedDate(null);
    } //Always reset currentMonth to null when CalendarView loads
    setCurrentMonth(null);
  
    //After resetting currentMonth, call fetchCalendarDates() to load current month dates
    if (selectedTimeZone) {
    fetchCalendarDates();
    
    }
    
  }, []);
  
  useEffect(() => {
    if (selectedTimeZone) {
      fetchCalendarDates(); // Fetch dates when the selected time zone changes
    }
  }, [selectedTimeZone, SlotType, calendarType, currentMonth]);

  useEffect(() => {
    if (selectedTimeZone && currentMonth !== null) {
      fetchCalendarDates();
    }
  }, [selectedTimeZone, currentMonth]);
  
  const fetchCalendarDates = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("AccessToken");
      var utcDiff='';
      var firstDayOfMonthDate='';
      let formattedDate;
      if(selectedTimeZone!="")
      {
        const today = new Date();
        firstDayOfMonthDate= new Date(
          currentMonth === null ? today.getFullYear() : currentMonth.getFullYear(),
          currentMonth === null ? today.getMonth() : currentMonth.getMonth(), 1);
        formattedDate = formatDate(firstDayOfMonthDate);
        setFormattedDate(formattedDate);
        const utcDiffObj=timeZoneData.find((tz) => tz.TimeZone.trim() === timeZone1.trim());
        utcDiff=utcDiffObj.UTCOffset;
      }
      else{
         // Detect user's timezone automatically on component load
         const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
         utcDiff = getUTCDifference();
         // Attempt to (match the user's timezone with available time zones from the API response
         const matchedTimeZone = timeZoneData.find(
           (tz) => tz.UTCOffset === utcDiff && tz.TimeZone.includes(userTimezone)
         ) || timeZoneData.find((tz) => tz.UTCOffset === utcDiff);
   
         // Set the selected time zone or default
         setSelectedTimeZone(matchedTimeZone ? matchedTimeZone.TimeZone : 'Eastern Standard Time');
   
         // Get the first day of the current month formatted as MM/DD/YYYY
         const today = new Date();
         firstDayOfMonthDate = new Date(
         currentMonth === null ? today.getFullYear() : currentMonth.getFullYear(), 
         currentMonth === null ? today.getMonth() : currentMonth.getMonth(), 1);

         formattedDate = formatDate(firstDayOfMonthDate);
         setFormattedDate(formattedDate);
    }
    const calculatedOffSet = -firstDayOfMonthDate.getTimezoneOffset() * 60 * 1000;
      setOffSet(calculatedOffSet); // Set OffSet in state
      setOffsetDiff(utcDiff);
    // Set up parameters based on timezone and date

    // Clean the selectedTimeZone before sending in the API request
    const cleanedTimeZone = selectedTimeZone.replace(/^UTC\([+-]\d{2}:\d{2}\)\s*/, "");

    const params = {
      OffSet: calculatedOffSet,
      SlotType: SlotType ,
      TimeZoneName: cleanedTimeZone,
      Date: formattedDate,
      EmailID: emailId.userData.EmailID,
      CalendarType: calendarType,
      OffsetDiff: utcDiff,
      DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
    };

       // Serialize the params object using qs
    const serializedParams = qs.stringify({ _Params: JSON.stringify(params) });

      const response = await axios.post(
        Endpoints.fetchCalendarDates,
        serializedParams,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Connection": "close",
            "Accept": "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data && response.data.Date) {
        console.log(response.data);
        setLoadCalendarInfo(response.data)
        // Transform calendar dates into the desired format
      const transformedDates = response.data.Date.map((date) => ({ start: date }));
      console.log("Transformed Dates:", transformedDates);
      setCalendarDates(transformedDates);
      } else {
        console.error("API response does not contain dates", response.data);
      }
     } catch (error) {
       console.error("Failed to fetch calendar dates:", error);
     }
     finally {
      setLoading(false);
    }
  };

const handleTimeZoneSelection = async (option) => {
  const matchedTimeZone = timeZoneData.find(tz =>
    option.includes(tz.TimeZone) && option.includes(tz.UTCOffset)
  );

  if (matchedTimeZone) {
    // Update state first
    setTimeZone(matchedTimeZone.TimeZone);
    setSelectedTimeZone(option);
    setSelectedTimeZoneOffset(matchedTimeZone.UTCOffset);

    // Fetch calendar dates after state updates
    const today = new Date();
    const firstDayOfMonthDate = new Date(
      currentMonth === null ? today.getFullYear() : currentMonth.getFullYear(),
      currentMonth === null ? today.getMonth() : currentMonth.getMonth(),
      1
    );

    const formattedDate = formatDate(firstDayOfMonthDate);

    const params = {
      OffSet: -firstDayOfMonthDate.getTimezoneOffset() * 60 * 1000,
      SlotType: SlotType,
      TimeZoneName: matchedTimeZone.TimeZone,
      Date: formattedDate,
      EmailID: emailId.userData.EmailID,
      CalendarType: calendarType,
      OffsetDiff: matchedTimeZone.UTCOffset,
      DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
    };

    // Use a helper function to fetch and update calendar dates
    fetchAndUpdateCalendarDates(params);
  } else {
    console.error("Selected time zone does not match available options");
  }
};

// Helper function to fetch calendar dates
const fetchAndUpdateCalendarDates = async (params) => {
  try {
    const token = localStorage.getItem("AccessToken");
    const serializedParams = qs.stringify({ _Params: JSON.stringify(params) });
    const response = await axios.post(
      Endpoints.fetchCalendarDates,
      serializedParams,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Connection": "close",
          "Accept": "*/*",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    
    if (response.data && response.data.Date) {
      const transformedDates = response.data.Date.map(date => ({ start: date }));
      setCalendarDates(transformedDates);
      console.log("Updated Calendar Dates:", transformedDates);
    } else {
      console.error("API response does not contain dates", response.data);
    }
  } catch (error) {
    console.error("Failed to fetch calendar dates:", error);
  }
};


const updateCalendarDates = (selectedTimeZone) => {
  // Implement logic to update calendar dates based on the selected time zone
  console.log("Selected Time Zone for Calendar:", selectedTimeZone);
};

  const formatDate = (date) => {
    return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${
      date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
  };
   // Function to handle the selected date
   const handleDateSelection = (date) => {
    
      // setSelectedDate(date); // Update the selected date in the state
      // console.log("Selected Date:", date); // Log the selected date

      const formatDate = (date) => {
        const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() returns month index starting from 0
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}${day}${year}`;
      };

    const formattedDate = formatDate(date);
    setSelectedDate(date); // Update the selected date in the state
    console.log("Selected Date (formatted):", formattedDate); // Log the formatted date
    
  };

  const handleMonthChange = (firstDayOfMonth) => {
    setCurrentMonth(firstDayOfMonth);
  };

  const getConfig = () => {
      return {
        type: "appointment",
        availability: calendarDates,
        onDateSelect: handleDateSelection,
        onMonthChange: handleMonthChange,
      };
  };

  const handleNextClick = () => {
    if (!selectedDate) {
      setModalMessage("Please click on an available date.");
      setShowModal(true);
      return;
    }
  // Convert available dates to YYYY-MM-DD format for comparison
  const availableDates = calendarDates.map(date => {
    //return new Date(date.start).toString().split('T')[0]; 
    return date.start;
  });
  console.log(availableDates)
    // Convert available dates to `toDateString()` format for comparison
   // const availableDates = calendarDates.map(date => new Date(date.start).toDateString());
    //const selectedDateString = new Date(selectedDate).toDateString();

    const formatDate = (date) => {
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based, so add 1
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
  };

    // Convert selected date to YYYY-MM-DD format
  const selectedDateString = formatDate(new Date(selectedDate));
  
    // Check if the selected date matches any available date
    const isDateAvailable = availableDates.includes(selectedDateString);
  
    if (isDateAvailable) {
      sessionStorage.setItem('clearStateOnBack', 'true');
      const cleanedTimeZone = selectedTimeZone.replace(/^UTC\([+-]\d{2}:\d{2}\)\s*/, "");
debugger;
      // Check if PrimaryNurse exists, set CalendarType accordingly
    let nextCalendarType = calendarType;
    if (selectedType === 'Nurse' && loadCalendarInfo?.PrimaryNurse && nextCalendarType!=='All') {
      nextCalendarType = "Primary";
    }
      //const updatedOffsetDiff = cleanedTimeZone === "Eastern Standard Time" ? "-04:00" : OffsetDiff;
      // Navigate to the next component if the date is available
      navigate("/schedule-time-slot", { state: { selectedDate, selectedTimeZone : cleanedTimeZone , selectedType, appointmentType, SlotType ,OffSet, OffsetDiff,calendarType: nextCalendarType } });
    } else {
      // Show alert if the date is not available
      setModalMessage(t('modalmessage'));
      setShowModal(true);
    }
  };
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }


  const handleBackClick = () => {
    if ((location.state && location.state.fromSSO) || (location.state?.from && location.state?.from === "/welcome")) {
    navigate('/home');
  } else {
    navigate(-1);
  }
  };
  const handleAllNurse =()=>{
    console.log("Calendar Type before toggle:", calendarType);
    setCalendarType(prev => {
      console.log("Calendar Type inside toggle function:", prev);
      if(prev === 'All'){
        console.log("Switching to Primary");
        return 'Primary';
      }
      else{
        console.log("Switching to All");
        return 'All';
      }
    });
  }
    return <>
    

    <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
      <button className="win-back-btn win-back-btn-2line-heading-mobile-view" onClick={handleBackClick}><span><i class='bi bi-chevron-left'></i>{t('Back')}</span></button>
      <h2 className="page-heading">{t('allAdvocateAvailability', { selectedType })}</h2>
    </div>
    <div className="col-md-12 col-lg-6 col-xl-5 mt-md-5">
      <CalendarComponent config={getConfig()} Date={selectedDate} />      
    </div>
    <div className="col-md-12 col-lg-5 calender-view-right-buttons-wrapper mb-5">
      <div className="custom-height highmark-order-2 mt-3 mt-md-0">
        <label className="form-label win-form-label me-md-2">{t('availabilityBasedOnTimeZone')}</label>
          <CustomDropdown
            options={timeZoneData.map(
              tz => `UTC(${tz.UTCOffset}) ${tz.TimeZone}`
            )}
            selectedOption={selectedTimeZone}
            onChange={handleTimeZoneSelection}
            searchable={true}
            isLoading={isItemsLoading}
          />
        </div>
        <div class="calendar-view-text-block-in-gap highmark-order-1 mt-2 mb-2">
         {/* Show nurse image if available */}
          {loadCalendarInfo?.NurseImgURL && selectedType === 'Nurse'&& (calendarType === 'Primary' || calendarType === '') && (
            <div className="nurse-img-wrapper mb-2 text-center">
              <img
                src={loadCalendarInfo.NurseImgURL}
                alt={loadCalendarInfo.PrimaryNurse || "Nurse"}
                style={{ maxWidth: 100, borderRadius: "100%" }}
              />
            </div>
          )}
        <h2>{t('scheduleAppointment')}</h2>
        <div>
        {selectedType === 'Nurse' && loadCalendarInfo?.PrimaryNurse &&(
        calendarType === 'Primary' || calendarType === '' ?  (
        loadCalendarInfo?.PrimaryNurse
          ? <span>{t('withYourPrimaryNurse', { primaryNurse: '' })}
          <strong style={{ fontSize: '1.2rem' }}>
            {loadCalendarInfo.PrimaryNurse}
          </strong></span>
          : null // Don't show the span if PrimaryNurse is not present
      )
    :  (
      <span>{t('withAllNurse')}</span>
    )
    )}
    </div>
        <p>
        {t('selectAvailableAdvocate', { selectedType })}
  </p>
  <div className="mt-3">
  {selectedType === 'Nurse' && loadCalendarInfo?.PrimaryNurse &&(
    <span
      onClick={handleAllNurse}
      className="win-btn-secondary-w-content highmark-option-no-border ps-0"
      style={{cursor: "pointer" }}
    >
      {calendarType === 'All'
        ? t('viewNurseAvailability', { nurse: loadCalendarInfo?.PrimaryNurse })
        : t('viewAllNurseAvailability')}
    </span>
    )}
  </div>
        </div>
        <button className="win-btn-primary mobile-view highmark-order-3 mx-auto mx-lg-0 d-block mt-4 mt-md-3" onClick={handleNextClick}>{t('nextbutton')}</button>
    </div>
    {/* <div className="col-md-12 d-flex align-items-end">
      
    </div> */}
    <ErrorModal show={showModal} message={modalMessage} onClose={() => setShowModal(false)} closeButton={true}  />
    </>;
  };
  
  export default CalendarView; 
